import React from 'react'
import { Link } from 'react-static'

import { trackedClick } from '../utils'

import ProviderLogo from './ProviderLogo'

const Intent = ({
    intent: { title, description, url, hasIntegrated, countMore, providers },
}) => (
    <div className="model-cards__item animate-appear">
        <Link
            className="model-card"
            component="div"
            onClick={trackedClick('Go to catalog clicked', {
                source: 'Intent card',
                title,
            })}
            to={`/api-platform/${url}`}
            href={`/api-platform/${url}`}
            title={hasIntegrated ? 'Try it' : 'Explore'}
        >
            <div className="model-card__inner">
                <div className="model-card__desc">
                    <h3 className="model-card__title">{title}</h3>
                    <p className="model-card__text">{description}</p>
                </div>
                <div className="model-card__logos">
                    <div className="model-card__logos-list">
                        {providers.map((provider, idx) => (
                            <ProviderLogo key={idx} provider={provider} />
                        ))}
                    </div>
                    {Boolean(countMore) && (
                        <div className="model-card__logos-more">
                            {`+${countMore} more`}
                        </div>
                    )}
                </div>
                <button className="model-card__button button button--blue button--outline">
                    {hasIntegrated ? 'Try it' : 'Explore'}
                </button>
            </div>
        </Link>
    </div>
)

export default Intent



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/Intent.jsx